import { SimpleGrid, SimpleGridProps } from '@chakra-ui/layout';
import React from 'react';

export const CmSimpleGrid: React.FC<SimpleGridProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <SimpleGrid {...rest}>{children}</SimpleGrid>;
};
